<template>
  <div>
    <el-dialog title="编辑" v-dialogDrag :visible.sync="dialogFormVisible" width="500px">
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="110px"
      >
        <el-form-item label="备注内容" prop="email">
          <el-input
            v-model="dataObj.remark"
            placeholder="请输入"
            class="input-width-two"
            type="textarea" 
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogFormVisible = false"
          v-preventReClick="5000"
          :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkEdit('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 编辑邮件备注对话框组件（eBay 版，复制自 amazonemail 版本）
 * 功能：回显父组件传入的 scope 数据，编辑邮件备注内容并调用 editorderRemark 接口保存
 */
import { editorderRemark } from "@/api/user";
export default {
  name: "edit",
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 表单校验规则（当前为空，实际无校验）
      rules: {},
      // 备注表单数据：邮件 id、订单号、备注内容
      dataObj: {
        id: "",
        orderNo: "",
        remark: "",
      },
      // 按钮禁用状态（防止重复提交）
      disabled: false,
      // 弹窗显示状态
      dialogFormVisible: true,
    };
  },
  created() {
    // 组件创建时回显当前邮件的备注数据
    this.handleClick();
  },
  methods: {
    /** 回显父组件传入的 scope 数据到表单 */
    handleClick() {
      Object.assign(this.dataObj, this.scope);
    },
    /** 关闭弹窗并通知父组件刷新列表 */
    close() {
      this.$emit("getList");
      this.$emit("isShowEdit");
    },
    /**
     * 校验表单并保存备注
     * @param {String} formName 表单 ref 名称
     */
    checkEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          editorderRemark(this.dataObj).then((result) => {
            if (result.code == 200) {
              this.$message({
                message: result.msg,
                type: "success",
              });
              this.$emit("getList");
              this.$emit("isShowEdit");
            }
          });
        }
      });
    },
  },
};
</script>